import { type ReactNode } from 'react';
import { Navigate } from 'react-router';
import { useAuth } from '@/features/auth/hooks';
import type { UserRole } from '@/features/auth/types';

/**
 * Route guard that requires a specific role.
 * Must be nested inside `<RequireAuth>` – assumes authentication is resolved.
 *
 * > **Important:** This is a UX convenience only.
 * > The backend MUST enforce permissions and resource ownership independently.
 */
export function RequireRole({
  role,
  children,
}: {
  role: UserRole;
  children: ReactNode;
}) {
  const { user } = useAuth();

  if (!user || user.role !== role) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
